import { UiService } from '../UiService';

export default class WaitScreen {
    /**
     * WaitScreen constructor
     * @param {UiService} uiService
     */
    constructor(uiService) {
        this.uiService = uiService;
    }

    display() {
        this.uiService.switchScreen('#wait');
    }
}
